import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["icon"];
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Text } from 'hoi-poi-ui';
import { useWeb5Context } from "../../../lib/Web5Context";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'EmptyView');
const EmptyView = /*#__PURE__*/memo(_ref => {
  let {
      icon
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const classes = useStyles();
  const {
    t
  } = useWeb5Context();
  const title = props.title || t('error_notresultfound');
  const subtitle = props.subtitle || t('cfm_label_empty_list');
  const button = props.button;
  const iconType = props.iconType ? props.iconType : 'icon';
  let iconClass = classes.emptyIcon;
  if (iconType === 'icon') {
    iconClass = classes.emptyIcon;
  } else if (iconType === 'bigIcon') {
    iconClass = classes.emptyBigIcon;
  } else if (iconType === 'image') {
    iconClass = classes.emptyImage;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.viewContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.emptyView
  }, icon && /*#__PURE__*/React.createElement("div", {
    className: iconClass
  }, icon), /*#__PURE__*/React.createElement(Text, {
    size: "big",
    bold: true
  }, title), /*#__PURE__*/React.createElement(Text, null, subtitle), button && /*#__PURE__*/React.createElement("div", {
    className: classes.emptyButton
  }, button)));
});
process.env.NODE_ENV !== "production" ? EmptyView.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  button: PropTypes.element
} : void 0;
export default EmptyView;